export const styles = {
  container: {
    backgroundColor: '#FFFFFF',
    marginBottom: '1rem',
  },
  svg: {
    width: '32px',
    height: '38px',
  },
  fileName: {
    fontSize: '1rem',
    fontWeight: 600,
  },
  fileDescription: {
    fontSize: '0.75rem',
    fontWeight: 400,
  },
  uploadButton: {
    color: '#65C687',
    borderColor: '#65C687',
  },
  hiddenInput: {
    display: 'none',
  },
};
